// Unified brand: 206Gravel.
//
// The business operates as a single brand — 206Gravel — across the entire
// Puget Sound metro. The 253gravel.com and 425gravel.com domains are still
// owned but are no longer separate brands; they serve this same app, and every
// visitor sees the one 206Gravel identity regardless of how they arrived.
//
// This module therefore describes exactly ONE region. It exists only as a
// single source of truth for the brand's area name, representative cities, map
// center, and default delivery zone. Coverage across the 206, 425, and 253
// area codes is communicated through copy and reviews, never through
// per-domain theming.
export type RegionCode = '206'

export interface RegionMeta {
  code: RegionCode
  /** Human-readable area name, e.g. "Seattle". */
  name: string
  /** Short descriptor used in copy, e.g. "Seattle proper". */
  label: string
  /** Representative cities for the region. */
  cities: string[]
  /** Map center coordinates [lat, lng]. */
  center: [number, number]
  /** Default delivery zone. */
  defaultZone: number
}

export const REGIONS: Record<RegionCode, RegionMeta> = {
  '206': {
    code: '206',
    name: 'Seattle',
    label: 'Seattle proper',
    cities: ['Seattle', 'West Seattle', 'Mercer Island'],
    center: [47.6062, -122.3321], // Seattle
    defaultZone: 3,
  },
}

/** Resolve the active region. Single brand, so always '206'. */
export function getRegion(): RegionCode {
  return '206'
}

/** Convenience accessor for the active region's metadata. */
export function getRegionMeta(): RegionMeta {
  return REGIONS[getRegion()]
}
